import DOMPurify from 'isomorphic-dompurify';

// eslint-disable-next-line import/prefer-default-export
export const isDOMPurifySupported = () => DOMPurify.isSupported;
